import { useTranslation } from 'react-i18next';

export const MAIN_CONTENT_ID = 'main-content';

/**
 * WCAG 2.2 AA bypass block. Visually hidden until focused, then fully visible —
 * a skip link that stays hidden on focus fails the criterion it exists for.
 */
export function SkipToContent() {
  const { t } = useTranslation();
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
    >
      {t('app.skipToContent')}
    </a>
  );
}
